// @flow
import { useContext } from 'react';
import OrgsContext, { type OrgsContextType } from './OrgsContext';

const useRequestsData = (): OrgsContextType => useContext(OrgsContext);
export default useRequestsData;
